import { render, staticRenderFns } from "./PriceDevelopmentInLocalCurrency.vue?vue&type=template&id=3a090f79&"
import script from "./PriceDevelopmentInLocalCurrency.vue?vue&type=script&lang=js&"
export * from "./PriceDevelopmentInLocalCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports